import {createTranslateLoader, getLoginEndPoint, getProduction} from '../app/app.module';

export const environment = {
  production: false,
  commonOptions: {
    createTranslateLoader,
    getLoginEndPoint,
    getProduction,
  } as any,
};
